// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__EJ7E4","header":"ReportDetails_header__jl5dK","title":"ReportDetails_title__15rnl","left":"ReportDetails_left__Iaivm"};